import { Injectable } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PopupComponent } from 'src/app/extensions/components/popup/popup.component';
import { DataSafety } from '../models/DataSafety';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class UnloadGuard {
  constructor(
    private _ngbModal: NgbModal,
    private _globalService: GlobalService,
    private _router: Router
  ) {}

  async canDeactivate(component: DataSafety): Promise<boolean> {
    if ((component.form != undefined && component.form.dirty) || component.canUnloadByPassForm) {
      const modal = this._ngbModal.open(PopupComponent);
      modal.componentInstance.title = 'common.confirmDataLossTitle';
      modal.componentInstance.description = 'common.confirmDataLoss';

      const modalResult = await modal.result;
      if (!modalResult) {
        this._globalService.pathChanged = this._router.url.split('/')[1];
      }
      return modalResult;
    }

    return true;
  }
}
